/*global WebView*/

var REQUIRED_FIELDS = [
    "street",
    "zip",
    "city",
] ;
var REQUIRED_FIELDS_COMPANY = REQUIRED_FIELDS.concat([
    "vat"
]) ;
var REQUIRED_FIELDS_PARTIC = REQUIRED_FIELDS.concat([

]) ;

function checkProspectFields(partner){
    var requiredField = REQUIRED_FIELDS_PARTIC ;
    if(partner.is_company){
        requiredField = REQUIRED_FIELDS_COMPANY ;
    }

    if(partner.country && partner.country.vat_label !== "VAT"){
        requiredField = requiredField.filter(function(field){ return field !== "vat" ; }) ;
    }

    var requiredFieldOk = requiredField.every(function(f){
        return partner[f] ;
    }) ;
    return requiredFieldOk ;
}

function checkProspectConvertionFullObject(partner, callback){
    var requiredFieldOk = checkProspectFields(partner) ;
    if(requiredFieldOk){
        //all required field are OK, 
        if(!partner.iz_prospect){
            //already customer, nothing to do
            return callback(null, []) ;
        }
        //add prospect convertion
        return callback(null, [
            { table: "res_partner", record : {
                id : partner.id,
                iz_prospect: false,
            } }
        ]) ;
    }

    //missing some fields, open popup
    var v = new WebView("modules/refs/views/customer", "prospectConvertPopup") ;
    v.openInPopup({
        closeByClickOutside: false,
        closeWithEsc: false,
        closeable: false,
        aboveAll: true,
        size: "medium",
        data: partner,
        title: WebView.tr("customer.neededInformationForPropsectConvert")
    }) ;
    v.on("cancel", function(){ 
        callback(WebView.tr("customer.missingInfoForPropsectConvert")) ;
        v.close() ;
    }) ;
    v.on("validate", function(){
        v.checkForm(function(err, formOk){
            if(err || !formOk){
                return;
            }
            v.updateData() ;
            if(partner.iz_prospect){
                partner.iz_prospect = false ;
            }
            v.close() ;
            return callback(null, [
                { table: "res_partner", action: "update", record :  partner }
            ]) ;
        }.bind(this)) ;
    }.bind(this)) ;

    v.on("country", function(){
        v.updateData() ;
        var data = v.getBoundObject() ;
        if(!data.country_id){
            data.country = null;
            return v.render() ;
        }
        WebView.longTask(function(done){
            window.app.context.api.db.multiread({
                res_country: { searchFirst: { id : data.country_id } }
            }, function(err, reads){
                if(err){ return done(err) ; }
                data.country = reads.res_country ;
                v.render() ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
}

/**
 * Check if the prospect convertion is possible
 * 
 * @param {date} partnerId the customer/prospect id
 * @param {function} callback
 */
function checkProspectConvertion(partnerId, callback){
    window.app.context.api.db.multiread({
        res_partner: { 
            searchFirst: {id: partnerId},
            joinFetch: [
                { otherTable: "res_country", name: "country", thisField: "country_id", otherField: "id"},
            ]
        }
    }, function(err, reads){
        if(err){ return callback(err) ;}
        var partner = reads.res_partner ;
        if(!partner){ return callback("partner not found") ;}
        // if(!partner.iz_prospect){
        //     //already customer, nothing to do
        //     return callback(null, []) ;
        // }

        checkProspectConvertionFullObject(partner, callback) ;
    });
} ;

module.exports.checkProspectConvertion = checkProspectConvertion ;
module.exports.checkProspectFields = checkProspectFields ;
module.exports.checkProspectConvertionFullObject = checkProspectConvertionFullObject ;